import React from 'react';
import cx from 'classnames';
import { Menu, MenuItem } from '../menu/menu';
import { Nav } from './styles';
export const NavItem = MenuItem;
export const LayoutNav = (props) => {
    return (React.createElement(Nav, { className: cx('layout-nav', props.className) },
        React.createElement("div", { className: "layout-nav-top", "data-role": "layout-nav-top" },
            props.logo,
            React.createElement(Menu, { menuTheme: "bgless" }, props.children)),
        props.bottom && (React.createElement("div", { className: "layout-nav-bottom", "data-role": "layout-nav-bottom" }, props.bottom))));
};
